import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export const SessionAvailability = ({ children }) => {
  const { user, loading, sessionError, refreshUser } = useAuth();
  const { pathname } = useLocation();
  const privatePage = pathname === "/" || /^\/(admin|academy|app)(\/|$)/.test(pathname);
  if (user || !sessionError || !privatePage) return children;
  return <main data-testid="session-check-unavailable" style={{ minHeight: "100dvh", background: "#FDFBF7",
    color: "#262923", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
    gap: 18, padding: 24, fontFamily: "Manrope", textAlign: "center" }}>
    <p role="alert" data-testid="session-check-message" style={{ maxWidth: 380, fontSize: 14, lineHeight: 1.7 }}>{sessionError}</p>
    <Button data-testid="session-check-retry" disabled={loading} onClick={refreshUser}
      style={{ background: "var(--ang-gold)", color: "var(--ang-bg-top)", maxWidth: "100%" }}>{loading ? "Проверяем…" : "Повторить проверку"}</Button>
  </main>;
};